import { LiveData, OnEvent, Service } from '@toeverything/infra';

// StreamLain: Automatic desktop handoff is disabled for web boot.
// Manual entry points still use showOpenInAppPage().
// import { resolveLinkToDoc } from '../../navigation';
import type { GlobalState } from '../../storage';
import { WorkbenchLocationChanged } from '../../workbench/services/workbench';
import type { WorkspacesService } from '../../workspace';
// import { getLocalWorkspaceIds } from '../../workspace-engine/impls/local';

const storageKey = 'open-link-mode';

export enum OpenLinkMode {
  ALWAYS_ASK = 'always-ask', // default
  OPEN_IN_WEB = 'open-in-web',
  OPEN_IN_DESKTOP_APP = 'open-in-desktop-app',
}

@OnEvent(WorkbenchLocationChanged, e => e.onNavigation)
export class OpenInAppService extends Service {
  // StreamLain: Automatic open-in-app bootstrap is intentionally disabled.
  // private initialized = false;
  // private initialUrl: string | undefined;

  readonly showOpenInAppBanner$ = new LiveData<boolean>(false);
  // Initialize to false since bootstrap() is disabled. The guard component
  // renders null when undefined, blocking the entire workspace.
  readonly showOpenInAppPage$ = new LiveData<boolean | undefined>(false);

  constructor(
    public readonly globalState: GlobalState,
    public readonly workspacesService: WorkspacesService
  ) {
    super();
  }

  onNavigation() {
    // The automatic banner is disabled, so navigation only needs to clear any
    // stale banner state.
    this.showOpenInAppBanner$.next(false);
  }

  /**
   * Given the initial URL, check if we need to redirect to the desktop app.
   *
   * DISABLED: automatic desktop redirects are too easy to false-positive in
   * browsers. Use explicit manual entry points instead.
   */
  bootstrap() {
    // Skip automatic open-in-app logic. This prevents surprise redirects for
    // shared docs and guest users.
    //
    // --- Original implementation (restore when desktop app is available) ---
    // if (this.initialized || !window) {
    //   return;
    // }
    //
    // this.initialized = true;
    // this.initialUrl = window.location.href;
    //
    // const maybeDocLink = resolveLinkToDoc(this.initialUrl);
    // let shouldOpenInApp = false;
    //
    // const localWorkspaceIds = getLocalWorkspaceIds();
    //
    // if (maybeDocLink && !localWorkspaceIds.includes(maybeDocLink.workspaceId)) {
    //   switch (this.getOpenLinkMode()) {
    //     case OpenLinkMode.OPEN_IN_DESKTOP_APP:
    //       shouldOpenInApp = true;
    //       break;
    //     case OpenLinkMode.ALWAYS_ASK:
    //       this.showOpenInAppBanner$.next(true);
    //       break;
    //     default:
    //       break;
    //   }
    // }
    // this.showOpenInAppPage$.next(shouldOpenInApp);
  }

  showOpenInAppPage() {
    this.showOpenInAppPage$.next(true);
  }

  hideOpenInAppPage() {
    this.showOpenInAppPage$.next(false);
  }

  getOpenLinkMode() {
    // StreamLain: default to web mode; desktop opening is explicit.
    return (
      this.globalState.get<OpenLinkMode>(storageKey) ?? OpenLinkMode.OPEN_IN_WEB
    );
  }

  openLinkMode$ = LiveData.from(
    this.globalState.watch<OpenLinkMode>(storageKey),
    this.getOpenLinkMode()
  ).map(v => v ?? OpenLinkMode.OPEN_IN_WEB);

  setOpenLinkMode(mode: OpenLinkMode) {
    this.globalState.set(storageKey, mode);
  }

  dismissBanner(rememberMode: OpenLinkMode | undefined) {
    if (rememberMode) {
      this.globalState.set(storageKey, rememberMode);
    }
    this.showOpenInAppBanner$.next(false);
  }
}
